module.exports = __webpack_public_path__ + "img/arrow.159984d4.png";